module.exports = __webpack_public_path__ + "img/el-menu.dc4f2637.svg";